import {Form, Formik} from "formik";
import React, {useEffect, useContext} from "react";
import request from "../../services/request";
import { useTranslation } from 'react-i18next';                   /* Added Line */
import { DEMAND_TYPES } from "../../shared/enums";
import { ThemeContext } from '../../../context/ThemeContext';


export default function FormikForm(props) {
    const [t, i18n] = useTranslation();         /* Added Line */
    const { changeSpinnerStatus, isDisAvukat } = useContext(ThemeContext);

    useEffect(() => {
        if (props.isUpdating) {
            fetchEntity();
        }
    }, [props.isUpdating]);

    useEffect(() => {
        if (props.configPointUrl) {
            fetchConfigData();
        }
    }, []);

    useEffect(() => {
        if (props.configPointUrl && props.configParameterValue) {
            fetchConfigData();
        }
    }, [props.configParameterValue]);

    const typeCheck = (type, filterValues = []) => {
        let index = filterValues.findIndex((fv) => fv == type);
    
        if (index != -1) {
          return true;
        }
    
        return false;
      };

    const onSubmit = (values, {setSubmitting, resetForm}) => {
        if (!values.type) {
            setTimeout(() => {
            setSubmitting(false);
        }, 400);
           return; 
        }
        const {arrangeBeforePersist, validateDataAfterSubmit} = props;
        let arrangedObject = null;

        if (arrangeBeforePersist) {
            arrangedObject = arrangeBeforePersist(values);
        }

        if (validateDataAfterSubmit && !validateDataAfterSubmit(arrangedObject)) {
            setSubmitting(false);
            return;
        }

        

        const body = {
            ...arrangedObject,
        };

        saveEntity(body, values.type, setSubmitting, resetForm);
    };

    const saveEntity = (payload, type, setSubmitting, resetForm) => {
        let url = "";
        if (type === 2) {
            url = props.endPointUrl2
        }else if(type === 3){
            url = props.endPointUrl3
        }else if(type === 4){
            url = props.endPointUrl4
        }else if (props.isUpdating) {
            url = props.editPointUrl
            if (isDisAvukat){
                url = "talep-girisi/update";
                if(props.disAvukatArsiv)
                    url=props.disAvukatArsiv;
            }
        }else{
            url = props.endPointUrl
        }

        
        request({
            url: url,
            method: "POST",
            data: {body: payload},
        }, changeSpinnerStatus).then((response) => {
            if (response.responseStatus === "SUCCESS") {
                if (props.closeModal) {
                    props.closeModal();
                }
                props.refreshList(response);
                if(props.resetAfterSubmit)
                    resetForm();
                    setSubmitting(false);
            }else{
                    setSubmitting(false);
            }
        }).catch((err)=>{
                setSubmitting(false);
        });
    };

    const fetchEntity = () => {
        request({
            url: props.fetchPointUrl,
            method: "POST",
            data: {
                body: {
                    [props.entityFetchId]: props.entityId,
                },
            },
        }, changeSpinnerStatus).then((response) => {
            if (response.responseStatus === "SUCCESS") {
                props.adaptDataForUpdate(response.body);
            }
        });
    };

    const fetchConfigData = () => {
        request({
            url: props.configPointUrl,
            method: props.configReqType || "GET",
            data: props.configReqType ? {
                body: {
                    [props.entityFetchId]: props.entityId || undefined,
                    [props.configParameterName]: props.configParameterValue || undefined
                }
            } : {}
        }, changeSpinnerStatus).then((response) => {
            if (response.responseStatus === "SUCCESS") {
                props.setConfigData(response.body);
            }
        });
    };

    return (
        <div>
            <Formik
                initialValues={props.initialValues}
                validationSchema={props.validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
                key={props.keyField || "formikForm"}
            >
                {({setFieldValue, handleSubmit, isSubmitting,}) => (
                    <Form key={props.keyField || "formikForm"}>
                        <div className="row">{props.children}</div>
                        {!props.hideFooterHr && <hr/>}
                        {!props.disableButtons && <div className="row">
                            <div className="col-lg-12">
                                {
                                    !isDisAvukat && props.extraButton && <button
                                        key={"extraButton"}
                                        disabled={isSubmitting}
                                        className="submit btn btn-danger float-right btn-sm ml-2"
                                        onClick={() => {props.extraButtonOnClick()}}
                                    >
                                        {props.extraButtonText}
                                    </button>
                                }
                                {
                                    !isDisAvukat && props.endPointUrl2 && <button
                                    key={"submitButton2"}
                                    className="submit btn btn-outline-dark float-right btn-sm ml-2"
                                    disabled={isSubmitting}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue("type", 2, false)
                                        handleSubmit()
                                    }}
                                >
                                    {props.secondSubmitButttonText || t("tamamlaButton.tamamla")}
                                    
                                </button>}
                                {
                                    !isDisAvukat && props.endPointUrl3 && <button
                                    key={"submitButton3"}
                                    className="submit btn btn-outline-info float-right btn-sm ml-2"
                                    disabled={isSubmitting}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue("type", 3, false)
                                        handleSubmit()
                                    }}
                                >
                                    {props.thirdSubmitButttonText || t("tamamlaButton.tamamla")}
                                </button>}
                                {
                                    !isDisAvukat && props.endPointUrl4 && <button
                                    key={"submitButton4"}
                                    className="submit btn btn-outline-success float-right btn-sm ml-2"
                                    disabled={isSubmitting}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue("type", 4, false)
                                        handleSubmit()
                                    }}
                                >
                                    {props.fourthSubmitButttonText || t("tamamlaButton.tamamla")}
                                </button>}

                                {
                                    !isDisAvukat && props.endPointUrl && <button
                                    key={"submitButton"}
                                    className="submit btn btn-primary float-right btn-sm"
                                    disabled={isSubmitting}
                                    onClick={(e) => {
                                        e.preventDefault(); // Firefoxta 2 kere submit yapıyor ondan eklendi.
                                        setFieldValue("type", 1, false)
                                        handleSubmit()
                                    }}
                                >
                                    {props.okButtonText || t("tamamlaButton.tamamla")}

                                </button>}

                                {
                                    isDisAvukat && <button
                                    key={"submitButton"}
                                    className="submit btn btn-primary float-right btn-sm"
                                    disabled={isSubmitting}
                                    onClick={(e) => {
                                        e.preventDefault(); // Firefoxta 2 kere submit yapıyor ondan eklendi.
                                        setFieldValue("type", 1, false)
                                        handleSubmit()
                                    }}
                                >
                                    {t("actionButtonGenerator.kaydet")}

                                </button>}


                            </div>
                        </div>}
                    </Form>
                )}
            </Formik>
        </div>
    );
}
